<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-bind:to="'/' + $i18n.locale + '/' + property.slug + '/' + $t('bookings.url')">
            {{ $t('bookings.name') }}
          </router-link>
        </li>
        <li class="breadcrumb-item" v-if="$route.params.bookingId" aria-current="page">{{ $t('editBooking') }}</li>
        <li class="breadcrumb-item active" aria-current="page" v-else>{{ $t('createBooking') }}</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">{{ $t('booking') }}</h1>
          <p class="lead text-muted">
            <span v-if="$route.params.bookingId">
              {{ $t('editBooking') }}
              {{$route.params.bookingId}}
            </span>
            <span v-else>{{ $t('createBooking') }}</span>
          </p>
        </div>
      </header>
      <div class="content">
        <div class="row">
          <div class="col-md-6 border-right">
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
              <form id="bookingForm">


                <div v-if="!$route.params.bookingId" class="mb-3">
                  <div class="d-flex flex-wrap">
                    <div class="custom-control custom-radio mr-4">
                      <input type="radio" id="radio-1" name="radio" class="custom-control-input form-control" checked="" @click="booking.status = 1">
                      <label class="custom-control-label" for="radio-1">{{ $t('createBooking') }}</label>
                    </div>
                    <div class="custom-control custom-radio mr-4">
                      <input type="radio" id="radio-2" name="radio" class="custom-control-input form-control" @click="booking.status = 4">
                      <label class="custom-control-label" for="radio-2">{{ $t('closeRoom') }}</label>
                    </div>
                  </div>
                </div>



                <h5>{{ $t('information.booking') }}</h5>
                <div v-if="booking.status == 4 || (booking.status == 0 && !booking.index)">
                  <Close v-bind.sync="{booking: booking, rooms: rooms}"></Close>
                </div>

                <div v-else>
                  <Booking v-bind.sync="{booking: booking, rooms: rooms, maxGuests: maxGuests, socket:socket}"></Booking>
                  <h5>{{ $t('information.payer') }}</h5>
                  <Payer v-bind.sync="{payer: booking.payer}"></Payer>

                  <h5>{{ $t('information.company') }}</h5>
                  <Company v-bind.sync="{company: booking.company}"></Company>

                  <div class="form-group">
                    <h5 for="booking.checkin">{{ $t('checkin') }}</h5>
                    <div class="btn-group" role="group" aria-label="...">
                      <button type="button" class="btn btn-primary checkin" :class="booking.checkin==0 ? 'disabled' : ''" v-bind:value=0 v-on:click="setCheckinStatus($event)">Not sent</button>
                      <button type="button" class="btn btn-primary checkin" :class="booking.checkin==1 ? 'disabled' : ''" v-bind:value=1 v-on:click="setCheckinStatus($event)">Sent</button>
                      <button type="button" class="btn btn-primary checkin" :class="booking.checkin==2 ? 'disabled' : ''" v-bind:value=2 v-on:click="setCheckinStatus($event)">Opened</button>
                    </div>
                  </div>
                </div>

                <div class="d-flex w-100">
                  <div class="btn-group btn-group-justified d-flex w-100 pb-5 pt-4">
                    <button v-b-modal.confirmDeleteModal type="button" name="cancel" class="btn btn-danger flex-grow-1" v-bind:class="{'disabled': !booking._id || booking.guests.find(g => g.index) || !booking.referer || booking.referer.channel != 'Hostomate.com'}">{{ $t('cancel') }}</button>
                    <button type="button" name="save" class="btn btn-primary flex-grow-1" @click="handleSubmit(submit)">{{ $t('save') }}</button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>

          <div class="col-md-6" v-if="$route.params.bookingId && [1,2,3].includes(booking.status)">
            <h5>{{ $t('guests') }}</h5>
            <Guests v-bind.sync="{guests: booking.guests, maxGuests: maxGuests}"></Guests>

            <br>

            <h5>{{ $t('invoices') }}</h5>
            <Invoices></Invoices>

          </div>
        </div>
      </div>
    </div>

    <ConfirmDelete ref="confirmDelete" v-bind.sync="{type: 'booking', delete: submit}"></ConfirmDelete>
  </div>
</template>

<script>
import Booking from './components/Booking.vue';
import Payer from './components/Payer.vue';
import Company from './components/Company.vue';
import Guests from './components/Guests.vue';
import Invoices from './components/Invoices.vue';
import Close from './components/Close.vue';
import moment from 'moment';

import ConfirmDelete from '../partials/modals/ConfirmDelete.vue';


export default {
  name: 'CreateBooking',
  components: {
     Booking, Payer, Guests, Invoices, Company, ConfirmDelete, Close
  },
  props: ['socket'],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name){
        vm.from = from.fullPath
      }else{
        vm.from = null
      }
    });
  },
  data: () => ({
    from: null,
    api: {
      url: '/bookings',
      method: 'post'
    },
    property: {
      slug:""
    },
    rooms: [],
    booking: {
      index: "",
      _id: "",
      status: 1,
      room: {
        _id: "",
      },
      unitId : "",
      /*unit: {
        _id: ""
      },*/
      property: {
        _id: ""
      },
      check: {
        in: "",
        out: ""
      },
      night: {
        first: "",
        last: ""
      },
      nuki: {},
      payer: {
        name: {
          first: "",
          last: ""
        },
        email:"",
        phone: {
          number: ""
        },
        country: "",
        comments: "",
      },
      guests: [],
      numGuests: {
        adults: '',
        children: ''
      },
      price: "",
      referer: {},
      company: {
        title: "",
        address: "",
        city: "",
        country: "",
        vat: ""
      },
      checkin:0,
    },
  }),
  created(){

    if(this.$route.params.bookingId){
      this.api.url = '/bookings/' + this.$route.params.bookingId;
      this.api.method = 'put'
      fetch(process.env.VUE_APP_API + this.api.url, {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(response => {

        this.booking = {
          index: response.index,
          _id: response._id,
          status:response.status,
          room: {
            _id: response.room._id,
          },
          unitId: response.unitId,
          property: {
            _id: response.property ? response.property._id : null
          },
          /*unit: {
            _id: response.unit ? response.unit._id : null,
          },*/
          check: {
            in: moment(response.night.first).toDate(),
            out: moment(response.night.last).add(1, 'days').toDate()
          },
          night: {
            first: response.night.first,
            last: response.night.last
          },
          nuki: response.nuki,
          payer: {
            name: {
              first: response.payer.name.first,
              last: response.payer.name.last
            },
            email: response.payer.email,
            phone: {
              number: response.payer.phone.number
            },
            country: response.payer.country,
            comments: response.payer.comments,
            vat: response.payer.vat
          },
          guests: response.guests,
          numGuests: {
            adults: response.numGuests.adults,
            children: response.numGuests.children
          },
          price: response.price,
          referer: response.referer,
          company: {
            title: response.company ? response.company.title : "",
            address: response.company ? response.company.address : "",
            city: response.company ? response.company.city : "",
            country: response.company ? response.company.country : "",
            vat: response.company ? response.company.vat : "",
          },
          checkin: response.checkin
        }
        this.property = this.$store.state.host.properties.find(p => p._id == this.booking.property._id);

        console.log("property");
        console.log(this.$store.state.host.properties);
        console.log(this.booking.property._id);
        console.log(this.booking);

        this.loadRooms();
      })
    }else{
      this.property = this.$store.state.host.properties.find(p => p.slug == this.$route.params.property);
      this.booking.night.first = window.sessionStorage.getItem('date');
      this.booking.night.last = window.sessionStorage.getItem('date');
      this.booking.check.in = moment(window.sessionStorage.getItem('date')).toDate();
      this.booking.check.out = moment(window.sessionStorage.getItem('date')).add(1, 'days').toDate()

      this.loadRooms();
    }
  },
  methods: {
    loadRooms: function(){
      return fetch( process.env.VUE_APP_API + '/rooms?property._id=' + this.property._id, {
        method : 'get',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => response.json())
      .then(response => {
        console.log(response)
        this.rooms = response;
      });
    },
    setCheckinStatus: function(e) {
      this.booking.checkin = parseInt(e.target.value);
    },
    submit: function(status = null){
      if(status === 0){
        this.booking.status = status;
        //if(!confirm("Are you sure you want to cancel this booking?")) return;
      }else if(!this.booking.status){
        this.booking.status = 1;
      }
      return fetch( process.env.VUE_APP_API + this.api.url, {
        method : this.api.method,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify({
          booking: this.booking,
          socket: {
            id: this.socket.id
          }
        })
      })
      .then(response => response.json())
      .then(response => {
        console.log(response)
        if(!response.error){
          if(this.from){
            this.$router.push(this.from);
          }else{
            this.$router.push('/' + this.$i18n.locale + '/' + this.property.slug + '/' + this.$t('calendar'));
          }
        }else{
          console.log(response.error);
          this.$refs.form.setErrors(response.error.messages);
        }
      });
    }
  },
  computed: {
    maxGuests: function(){
      let room = this.rooms.find(r => r._id == this.booking.room._id);
      if(room) return room.maxGuests;
      return 0;
    }
  }
}
</script>

<i18n>
{
  "en": {
    "calendar": "calendar",
    "booking": "Booking",
    "bookings": {
      "name": "Bookings",
      "url": "bookings"
    },
    "editBooking": "Edit Booking",
    "createBooking": "Create Booking",
    "closeRoom": "Close Room",
    "information": {
      "booking": "Booking information",
      "payer": "Payer Information",
      "company": "Company Information"
    },
    "guests": "Guests",
    "invoices": "Invoices",
    "cancel": "Cancel Booking",
    "save": "Save Booking",
    "checkin": "Check-in status"
  },
  "sl": {
    "calendar": "koledar",
    "booking": "Rezervacija",
    "bookings": {
      "name": "Rezervacije",
      "url": "rezervacije"
    },
    "editBooking": "Uredi rezervacijo",
    "createBooking": "Ustvari rezervacijo",
    "closeRoom": "Zapri sobo",
    "information": {
      "booking": "Podatki rezervacije",
      "payer": "Podatki plačnika",
      "company": "Podatki podjetja"
    },
    "guests": "Gostje",
    "invoices": "Računi",
    "cancel": "Prekliči rezervacijo",
    "save": "Shrani rezervacijo",
    "checkin": "Check-in status"
  }
}
</i18n>
